export function formErrorDecorator(
  arrayErrors: string[],
  mapping?: Record<string, string>
) {
  let newApiErrors: any = {};

  for (const errorString of arrayErrors) {
    const error = errorString.split(":");
    error[0] = error[0].replace("Valid", "");
    const key = mapping && mapping[error[0]] ? mapping[error[0]] : error[0];
    newApiErrors[key] = newApiErrors[key]
      ? `${newApiErrors[key]}<br />${error[1].trim()}`
      : error[1].trim();
  }
  return newApiErrors;
}
